import {UserLogout} from '../actions/authActions';

export const fetchWithAuth = async (url, options, dispatch) => {
  const resp = await fetch(url, options);

  if (resp.status === 401) {
    dispatch(UserLogout());
    return null;
  }

  return resp;
};